import clsx from "clsx";
import { motion } from "framer-motion";
import { useRouter } from "next/compat/router";

import type { IAppBarItem } from "./AppBar";

interface Props {
	item: IAppBarItem;
	isOverflowed?: boolean;
}

const AppBarItem = ({ item, isOverflowed }: Props) => {
	const Icon = item.icon;
	const router = useRouter();

	return (
		<motion.button
			whileTap={{
				scale: 0.9,
				opacity: 0.8,
			}}
			onClick={item.onClick ? item.onClick : () => router?.push(item.href)}
			className={clsx(
				"flex flex-col items-center gap-1 px-2 py-2 font-medium text-xs",
				{
					"!text-base flex-row gap-3 p-2": isOverflowed,
				},
			)}
		>
			<Icon size={20} />
			{item.shortLabel ? item.shortLabel : item.label}
		</motion.button>
	);
};

export default AppBarItem;
